import { z } from 'zod';

import type { WhatsNewEntryType as PrismaWhatsNewEntryType } from '@generated/prisma/enums';

// Re-export Prisma `WhatsNewEntryType` type
export type WhatsNewEntryType = PrismaWhatsNewEntryType;

export const WhatsNewEntryType: { [K in PrismaWhatsNewEntryType]: K } = {
  FEATURE: 'FEATURE',
  NEWS: 'NEWS',
  ACTION_REQUIRED: 'ACTION_REQUIRED',
};

export const whatsNewEntryTypeSchema = z.enum(WhatsNewEntryType);

/**
 * Checks if the given value is a valid WhatsNewEntryType.
 */
export function isWhatsNewEntryType(value: unknown): value is WhatsNewEntryType {
  return whatsNewEntryTypeSchema.safeParse(value).success;
}
